export enum RegistrationTypes {
  INDIVIDUAL = 'INDIVIDUAL',
  JOINT = 'JOINT',
  BUSINESS = 'BUSINESS'
}

export enum RegistrationSubTypes {
  CHILD = 'CHILD'
}
